var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("viewForm", {
        ref: "viewForm",
        attrs: {
          "is-edit": false,
          "user-info": _vm.userInfo,
          "user-all-roles": _vm.userAllRoles,
          "is-customer": "",
        },
        on: { submit: _vm.submit },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("CustomerFunction.accountCreated"),
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            width: "40%",
            "before-close": _vm.dialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("h4", [
            _vm._v(
              _vm._s(_vm.$t("CustomerFunction.ClientCode")) +
                " : " +
                _vm._s(_vm.UserClientCode)
            ),
          ]),
          _c("h4", [
            _vm._v(
              _vm._s(_vm.$t("CustomerFunction.Account")) +
                " : " +
                _vm._s(_vm.UserLoginName)
            ),
          ]),
          _c("h4", [
            _vm._v(
              _vm._s(_vm.$t("CustomerFunction.Password")) +
                " : " +
                _vm._s(_vm.UserPassword)
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:copy",
                      value:
                        this.$t("CustomerFunction.ClientCode") +
                        " : " +
                        this.UserClientCode +
                        " ," +
                        this.$t("CustomerFunction.Account") +
                        " : " +
                        this.UserLoginName +
                        " ," +
                        this.$t("CustomerFunction.Password") +
                        " : " +
                        this.UserPassword +
                        ".",
                      expression:
                        "`${this.$t('CustomerFunction.ClientCode')} : ${this.UserClientCode} ,${this.$t('CustomerFunction.Account')} : ${this.UserLoginName} ,${this.$t('CustomerFunction.Password')} : ${this.UserPassword}.`",
                      arg: "copy",
                    },
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:success",
                      value: _vm.onCopySuccess,
                      expression: "onCopySuccess",
                      arg: "success",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.handlerConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("okText")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }